"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppPathGenerator = exports.PATH__LEGAL = exports.PATH__TEST_UG = exports.PATH__ADMIN__LEGACY = exports.PATH__ADMIN = exports.PATH__PROFILE = exports.PATH__PROJECT_FUNNEL = exports.PATH__PROJECT_EVENTS = exports.PATH__PROJECT_STICKINESS = exports.PATH__PROJECT_LIFECYCLE = exports.PATH__PROJECT_RETENTION = exports.PATH__PROJECT_NEW_USERS = exports.PATH__PROJECT_ACTIVE_USERS = exports.PATH__PROJECT_MEMBERS = exports.PATH__PROJECT_INTEGRATION = exports.PATH__PROJECT = exports.PATH__PROJECTS = exports.ANONYMOUS_PAGE_BRAND_GUIDELINES = exports.PATH__HOME = void 0;
const react_router_dom_1 = require("react-router-dom");
const query_string_1 = __importDefault(require("query-string"));
exports.PATH__HOME = "/";
////////////////////////////////////////////////
// Anonymous
////////////////////////////////////////////////
exports.ANONYMOUS_PAGE_BRAND_GUIDELINES = "/brandGuidelines";
////////////////////////////////////////////////
// Authorized
////////////////////////////////////////////////
exports.PATH__PROJECTS = "/projects";
exports.PATH__PROJECT = "/project/:projectApiKey";
exports.PATH__PROJECT_INTEGRATION = `${exports.PATH__PROJECT}/integration`;
exports.PATH__PROJECT_MEMBERS = `${exports.PATH__PROJECT}/members`;
exports.PATH__PROJECT_ACTIVE_USERS = `${exports.PATH__PROJECT}/activeUsers`;
exports.PATH__PROJECT_NEW_USERS = `${exports.PATH__PROJECT}/newUsers`;
exports.PATH__PROJECT_RETENTION = `${exports.PATH__PROJECT}/retention`;
exports.PATH__PROJECT_LIFECYCLE = `${exports.PATH__PROJECT}/lifecycle`;
exports.PATH__PROJECT_STICKINESS = `${exports.PATH__PROJECT}/stickiness`;
exports.PATH__PROJECT_EVENTS = `${exports.PATH__PROJECT}/events`;
exports.PATH__PROJECT_FUNNEL = `${exports.PATH__PROJECT}/funnel`;
exports.PATH__PROFILE = "/profile";
exports.PATH__ADMIN = "/admin";
exports.PATH__ADMIN__LEGACY = "/admin/legacy";
exports.PATH__TEST_UG = "/test_ug";
////////////////////////////////////////////////
// Common
////////////////////////////////////////////////
exports.PATH__LEGAL = "/legal";
exports.AppPathGenerator = {
    legal: () => (0, react_router_dom_1.generatePath)(exports.PATH__LEGAL),
    brandGuidelines: () => (0, react_router_dom_1.generatePath)(exports.ANONYMOUS_PAGE_BRAND_GUIDELINES),
    home: () => (0, react_router_dom_1.generatePath)(exports.PATH__HOME),
    projects: () => (0, react_router_dom_1.generatePath)(exports.PATH__PROJECTS),
    Profile: {
        home: () => exports.PATH__PROFILE
    },
    Project: {
        home: (projectApiKey) => {
            return (0, react_router_dom_1.generatePath)(exports.PATH__PROJECT, { projectApiKey });
        },
        integration: (projectApiKey) => {
            return (0, react_router_dom_1.generatePath)(exports.PATH__PROJECT_INTEGRATION, { projectApiKey });
        },
        members: (projectApiKey) => {
            return (0, react_router_dom_1.generatePath)(exports.PATH__PROJECT_MEMBERS, { projectApiKey });
        },
        activeUsers: (projectApiKey, serializedState) => {
            const path = query_string_1.default.stringifyUrl({ url: exports.PATH__PROJECT_ACTIVE_USERS, query: { state: serializedState ? JSON.stringify(serializedState) : undefined } });
            return (0, react_router_dom_1.generatePath)(path, { projectApiKey });
        },
        newUsers: (projectApiKey, serializedState) => {
            const path = query_string_1.default.stringifyUrl({ url: exports.PATH__PROJECT_NEW_USERS, query: { state: serializedState ? JSON.stringify(serializedState) : undefined } });
            return (0, react_router_dom_1.generatePath)(path, { projectApiKey });
        },
        retention: (projectApiKey, serializedState) => {
            const path = query_string_1.default.stringifyUrl({ url: exports.PATH__PROJECT_RETENTION, query: { state: serializedState ? JSON.stringify(serializedState) : undefined } });
            return (0, react_router_dom_1.generatePath)(path, { projectApiKey });
        },
        lifecycle: (projectApiKey, serializedState) => {
            const path = query_string_1.default.stringifyUrl({ url: exports.PATH__PROJECT_LIFECYCLE, query: { state: serializedState ? JSON.stringify(serializedState) : undefined } });
            return (0, react_router_dom_1.generatePath)(path, { projectApiKey });
        },
        stickiness: (projectApiKey, serializedState) => {
            const path = query_string_1.default.stringifyUrl({ url: exports.PATH__PROJECT_STICKINESS, query: { state: serializedState ? JSON.stringify(serializedState) : undefined } });
            return (0, react_router_dom_1.generatePath)(path, { projectApiKey });
        },
        events: (projectApiKey, serializedState) => {
            const path = query_string_1.default.stringifyUrl({ url: exports.PATH__PROJECT_EVENTS, query: { state: serializedState ? JSON.stringify(serializedState) : undefined } });
            return (0, react_router_dom_1.generatePath)(path, { projectApiKey });
        },
        funnel: (projectApiKey, serializedState) => {
            const path = query_string_1.default.stringifyUrl({ url: exports.PATH__PROJECT_FUNNEL, query: { state: serializedState ? JSON.stringify(serializedState) : undefined } });
            return (0, react_router_dom_1.generatePath)(path, { projectApiKey });
        },
    },
    github: {
        home: () => "https://github.com/usergeek/usergeek-ic-js"
    }
};
